
/**
 * src/hooks/useFlexible.ts 中计算font-size的设计稿尺寸
 */
export const FlexibleBase = 750
